<div class="position-absolute twc-d-flex flex-direction-column" [style.top.px]="position.top"
    [style.left.px]="position.left">
    <div class="twc-d-flex">
        <button class="twc-button twc-button-secondary twc-button-icon close-button" (click)="onClickClose()">
            <twc-icon shape="close" [size]="20"></twc-icon>
        </button>
    </div>
    <button *ngFor="let option of options; let i= index" class="twc-button twc-button-primary"
        (click)="onClickOption(option)" [ngClass]="{'border-top-button': i > 0}">
        <span>{{option.text | translate}}</span>
    </button>
</div>